import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm } from "../utils/typography"

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="All posts"
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <h2>What</h2>
        <hr className="pixelhr" />
        <p>Power Glove is a chiptune, tracker scene and video game OST show available online and on terrestrial radio.</p>
        <h2>When</h2>
        <hr className="pixelhr" />
        <p>The show isn't currently broadcasting on terrestrial radio, but will likely be back soon on <a href="http://www.ksuaradio.com/">KSUA 91.5 FM</a>, in College, Alaska, and can be heard in the Fairbanks North Star Borough listening area on terrestrial radio or streamed online at <a href="http://www.ksuaradio.com/stream">http://www.ksuaradio.com/stream</a>.</p>
        <h2>Who</h2>
        <hr className="pixelhr" />
        <p>Your host is DJ PARTY BOY XXXXXX420X, the funky futuristic robot who was born to groove <span role="img" aria-label="music note emoji">🎶</span></p>
        <br />
        <h2>Show Archive</h2>
        <hr className="pixelhr" />
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <div key={node.fields.slug}>
              <h3
                style={{
                  marginBottom: rhythm(1 / 4),
                }}
              >
                <Link style={{ boxShadow: `none` }} to={node.fields.slug}>
                  {title}
                </Link>
              </h3>
              <small>{node.frontmatter.date}</small>
              <p
                dangerouslySetInnerHTML={{
                  __html: node.frontmatter.description || node.excerpt,
                }}
              />
            </div>
          )
        })}
        <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
          <Link to="/archive">View complete archive</Link>
        </div>
        <br />
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 5, 
      filter: { frontmatter: {published:{eq: true}} },
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
          }
        }
      }
    }
  }
`
